import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { EventType, Router } from '@angular/router';
import { DynamicFacade } from '../../store/dynamic.facade';
import { filter, map, Observable, Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  standalone: false,
    selector: 'app-single-view',
    templateUrl: './single-view.component.html',
    styleUrls: ['./single-view.component.scss']
})
export class SingleViewComponent implements OnInit, OnDestroy, AfterViewInit {

    uiDefinition$: Observable<any> = this.dynamicFacade.uiDefinition$;

    private destroy$ = new Subject<void>();

    public isLoading: boolean = false;

    constructor(
        private dynamicFacade: DynamicFacade,
        private router: Router) {
    }

    ngOnInit(): void {
        //console.log('SingleViewComponent initialized with URL:', this.router.url);
        this.dynamicFacade.GetUiDefinitionFromUrl(this.router.url);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngAfterViewInit(): void {
        this.router.events.pipe(
            takeUntil(this.destroy$),
            filter(event => event.type == EventType.NavigationEnd),
            map((event) => event)
        ).subscribe(
            () => {
                //console.log('Navigation ended. Fetching UI definition for URL:', this.router.url);
                this.dynamicFacade.GetUiDefinitionFromUrl(this.router.url);
            }
        );
    }

}
